import { render, staticRenderFns } from "./RateVcDemo.vue?vue&type=template&id=3281ced0&scoped=true&"
import script from "./RateVcDemo.vue?vue&type=script&lang=js&"
export * from "./RateVcDemo.vue?vue&type=script&lang=js&"
import style0 from "./RateVcDemo.vue?vue&type=style&index=0&id=3281ced0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3281ced0",
  null
  
)

export default component.exports